import { useMutation } from '@apollo/client';
import NEW_ANNOTATION from 'graphql/fragments/NewAnnotation.graphql';
import CREATE_EPUB_ANNOTATION from 'graphql/mutations/epubAnnotations/CreateEpubAnnotation.graphql';

function _epubAnnotationsInDocumentFieldMethod(
  cache,
  createEpubAnnotation,
  documentIndex,
) {
  return (existingAnnotations) => {
    if (documentIndex !== createEpubAnnotation.epubAnnotation.documentIndex) {
      return { ...existingAnnotations };
    }

    const newAnnotationRef = cache.writeFragment({
      data: createEpubAnnotation.epubAnnotation,
      fragment: NEW_ANNOTATION,
    });

    return {
      __typename: existingAnnotations.__typeName,
      edges: [
        ...existingAnnotations.edges,
        {
          __typename: 'EpubAnnotationNodeEdge',
          node: newAnnotationRef,
        },
      ],
    };
  };
}

function _epubAnnotationsNotInDocumentFieldMethod(
  cache,
  createEpubAnnotation,
  documentIndex,
) {
  return (existingAnnotations) => {
    if (documentIndex === createEpubAnnotation.epubAnnotation.documentIndex) {
      return { ...existingAnnotations };
    }

    const newAnnotationRef = cache.writeFragment({
      data: createEpubAnnotation.epubAnnotation,
      fragment: NEW_ANNOTATION,
    });

    return {
      __typename: existingAnnotations.__typeName,
      edges: [
        ...existingAnnotations.edges,
        {
          __typename: 'EpubAnnotationNodeEdge',
          node: newAnnotationRef,
        },
      ],
    };
  };
}

export default function useCreateEpubAnnotationMutation(documentIndex) {
  return useMutation(CREATE_EPUB_ANNOTATION, {
    update(cache, { data: { createEpubAnnotation } }) {
      cache.modify({
        fields: {
          epubAnnotationsInDocument: _epubAnnotationsInDocumentFieldMethod(
            cache,
            createEpubAnnotation,
            documentIndex,
          ),
          epubAnnotationsNotInDocument:
            _epubAnnotationsNotInDocumentFieldMethod(
              cache,
              createEpubAnnotation,
              documentIndex,
            ),
        },
      });
    },
  });
}
